/** KAN-718: результат проверки почтового ящика (SMTP / IMAP) со временем проверки. */
import { formatCheckedAt } from '@/lib/telegramProxyDirectory';
import { mailboxCheckOk, mailboxCheckSummary } from '@/lib/emailMailboxForm';
import type { MailboxCheckResult } from '@/types/emailMailbox';

interface Props {
  result: MailboxCheckResult | null | undefined;
  testId: string;
}

export function MailboxCheckBadge({ result, testId }: Props): JSX.Element {
  if (!result) {
    return (
      <span className="text-xs text-gray-500" data-testid={testId} data-status="none">
        не проверялся
      </span>
    );
  }
  const ok = mailboxCheckOk(result);
  const at = formatCheckedAt(result.checked_at);
  return (
    <span
      className={`inline-flex flex-col rounded px-2 py-1 text-xs ${
        ok ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'
      }`}
      data-testid={testId}
      data-status={ok ? 'ok' : 'fail'}
    >
      <span>{mailboxCheckSummary(result)}</span>
      {at && <span className="text-[11px] opacity-75">{at}</span>}
    </span>
  );
}
